import axios from 'axios';
import { attachApiErrorToastInterceptor } from '../utils/api-error-toast';

export const axiosIns = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosIns);

axiosIns.interceptors.request.use((config) => {
  return config;
});

axiosIns.interceptors.response.use((response) => {
  return response;
});
